import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';

const AusenciasPorSedeYPromocion = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openSections, setOpenSections] = useState({}); // Estado para controlar las secciones abiertas

  useEffect(() => {
    // Función para obtener los datos de la API
    const fetchData = async () => {
      try {
        const response = await axios.post('https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/obtenerAusenciasRegulares');
        setData(response.data.informe); // Asumimos que la respuesta contiene 'informe'
        setLoading(false);
      } catch (err) {
        setError('Error al obtener los datos');
        setLoading(false);
      }
    };

    // Llamar a la función fetchData cuando el componente se monte
    fetchData();
  }, []);

  // Organizar los datos por sede y luego por promoción
  const groupedData = data.reduce((acc, item) => {
    const sede = item.cadeteSede;
    const promocion = item.promocion;

    if (!acc[sede]) {
      acc[sede] = {}; // Crear un nuevo objeto para la sede si no existe
    }

    if (!acc[sede][promocion]) {
      acc[sede][promocion] = [];
    }

    acc[sede][promocion].push(item); // Agrupar las ausencias por promoción dentro de cada sede

    return acc;
  }, {});

  // Función para exportar los datos a Excel
  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
      Nro: index + 1,
      CadeteInfo: item.cadeteInfo,
      CadeteDni: item.cadeteDni,
      CadeteSede: item.cadeteSede,  // Agregar el campo cadeteSede
      Promocion: item.promocion,    // Agregar el campo promocion
      CantidadAusencias: item.cantidadAusencias,
      FechasAusencias: item.fechasAusencias
    })));
    const fecha=new Date()
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Ausencias');
    XLSX.writeFile(wb, 'AusenciasCadetesTotales_al_'+fecha.toLocaleDateString()+'.xlsx');
  };

  // Función para alternar la visibilidad de las secciones
  const toggleSection = (section) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section]
    }));
  };

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
const abreDatas=(c)=>{
    window.open('/CadeteEdit?dni=' + c.cadeteDni, '_blank');
}
  return (
    <div>
          <div style={{display:'flex',justifyContent:"center"}}>
      <button className='btn btn-primary' onClick={exportToExcel}>Exportar a Excel</button>
      </div>
      {Object.keys(groupedData).map((sede, index) => (
        <div key={sede}>
          <h2 onClick={() => toggleSection(sede)} style={{ cursor: 'pointer' }}>
            {index + 1}. Sede: {sede} {openSections[sede] ? '▼' : '▶'}
          </h2>
          {openSections[sede] && (
            <div>
              {Object.keys(groupedData[sede]).map((promocion, promoIndex) => (
                <div key={promocion}>
                  <h3 onClick={() => toggleSection(`${sede}-${promocion}`)} style={{ cursor: 'pointer' }}>
                    {promoIndex + 1}. Promoción: {promocion} {openSections[`${sede}-${promocion}`] ? '▼' : '▶'}
                  </h3>
                  {openSections[`${sede}-${promocion}`] && (
                    <ul>
                      {groupedData[sede][promocion].map((item, itemIndex) => (
                        <a key={itemIndex} >
                        <strong style={{ cursor: 'pointer' }} onClick={()=>abreDatas(item)}>{itemIndex + 1}. {item.cadeteInfo + " ("+item.cadeteDni+")"}</strong> <p>Cantidad de ausencias: <strong style={{color:"red"}}>{item.cantidadAusencias}</strong> {" ("+ item.fechasAusencias+") "} </p>
                        
                      
                      </a>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default AusenciasPorSedeYPromocion;

